
import { useSelector } from 'react-redux';
import PackageAndSerivceModel from '../model/PackageAndSerivceModel';

const HandlePackageAndServiceModel = () => {
    const OpenPackageAndServiceModel = useSelector(
    (state: { modal: { packageAndServiceModel: boolean } }) => state.modal.packageAndServiceModel
  );
  return (
    <>
      {OpenPackageAndServiceModel && <PackageAndSerivceModel />}
    </>
  )
}

export default HandlePackageAndServiceModel
